import ApplicationController from '../application_controller'

class DatevNowOrDelayedUpdateController extends ApplicationController {
  static targets = ['updateNow', 'delayedUpdate', 'delayedDate']
  static values = { formId: String }

  connect () {
    if (this.hasDelayedDateTarget) window.Forms.initDatePickers(this.element)
  }

  showModal (event) {
    event.preventDefault()
    $('#employees_datev_now_or_delayed_update_modal').modal('show')
  }

  handleSubmit (event) {
    event.preventDefault()
    const form = document.getElementById(this.formIdValue)

    if (this.delayedUpdateTarget.checked) {
      const delayedUpdateInput = document.createElement('input')
      delayedUpdateInput.setAttribute('type', 'hidden')
      delayedUpdateInput.setAttribute('name', 'delayed_date')
      delayedUpdateInput.setAttribute('value', this.delayedDateTarget.value)
      form.appendChild(delayedUpdateInput)
    }

    form.submit()
  }

  showHideDate (_event) {
    const mobileDatePickerInput = this.delayedDateTarget.parentElement.querySelector('.flatpickr-mobile')

    if (this.delayedUpdateTarget.checked) {
      this.delayedDateTarget.classList.remove('d-none')
      mobileDatePickerInput?.classList?.remove('d-none')
    } else {
      this.delayedDateTarget.classList.add('d-none')
      mobileDatePickerInput?.classList?.add('d-none')
    }
  }
}

export default DatevNowOrDelayedUpdateController
